var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 129,
    viewBox: "0 0 29 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9681 127.585C23.1167 129.249 19.4447 128.292 17.8961 125.376C8.07132 106.876 2.24684 86.4907 0.830015 65.5469C-0.586808 44.603 2.43911 23.6192 9.68282 3.96458C10.8245 0.866737 14.3342 -0.576239 17.3838 0.688794C20.4333 1.95384 21.8669 5.4475 20.736 8.54932C14.1927 26.4968 11.4663 45.6365 12.7587 64.7399C14.051 83.8433 19.3303 102.441 28.2312 119.344C29.7695 122.265 28.8195 125.92 25.9681 127.585Z",
    fill: "url(#paint0_linear_710_30225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_30225",
    x1: 147.992,
    y1: -93.5023,
    x2: 150.988,
    y2: 204.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D4EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FC69A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2E86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBorder);
export default __webpack_public_path__ + "static/media/left-border.ae0208a1985b3661be6eb5dbb1ebae13.svg";
export { ForwardRef as ReactComponent };